const API = process.env.REACT_APP_BACKEND_URL;

export const backendUrl = API;

export const po = async (path, token, body = {}) => {
  const r = await fetch(`${API}/api/pickup-orders/${path}`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ token, ...body }) });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(typeof d.detail === "string" ? d.detail : "Request failed");
  return d;
};

export const poPdf = async (token, id, ref) => {
  const r = await fetch(`${API}/api/pickup-orders/pdf`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ token, id }) });
  if (!r.ok) throw new Error("PDF failed");
  const url = URL.createObjectURL(await r.blob());
  const a = document.createElement("a");
  a.href = url; a.download = `${ref}.pdf`; a.click();
  URL.revokeObjectURL(url);
};

export const STATUS_LABEL = {
  ENQUIRY: "Enquiry", PAYMENT_PENDING: "Payment Pending", PAYMENT_UNDER_VERIFICATION: "Payment Under Verification", PAID: "Paid",
  CONFIRMED: "Confirmed", READY_FOR_PICKUP: "Ready for Pickup", COLLECTED: "Collected", CANCELLED: "Cancelled",
};
export const STATUS_CLS = {
  ENQUIRY: "bg-sky-100 text-sky-800", PAYMENT_PENDING: "bg-amber-100 text-amber-800", PAYMENT_UNDER_VERIFICATION: "bg-orange-100 text-orange-800",
  PAID: "bg-emerald-100 text-emerald-800", CONFIRMED: "bg-teal-100 text-teal-800", READY_FOR_PICKUP: "bg-violet-100 text-violet-800",
  COLLECTED: "bg-stone-200 text-stone-700", CANCELLED: "bg-red-100 text-red-700",
};
export const money = (sym, v) => `${sym}${Number(v || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
